module.exports = __webpack_public_path__ + "static/media/17import-39.632bd04e.xlsx";